export default __webpack_public_path__ + "static/media/caps03.f19f6990.gif";